import { Company, FrenchCompany } from '@modules-deprecated/app/companies/types'

export const isFrenchCompany = (
  company: Partial<Company> | Partial<FrenchCompany>,
): company is Partial<FrenchCompany> => {
  return 'siren' in company || 'siret' in company
}
